import {createRoutesFromElements, Route} from 'react-router-dom';
import {Main} from '@/apps/main-frontend/pages';
import {NewsPage} from '@/apps/main-frontend/pages';
import {NewsDetailPage} from '@/apps/main-frontend/pages';
import {AvatarPage} from '@/apps/main-frontend/pages/avatar-page';
import {PrivacyPage} from '@/apps/main-frontend/pages/privacy-page';
import {UserPage} from '@/apps/main-frontend/pages/user-page';
import {VoucherPage} from '@/apps/main-frontend/pages/voucher-page';

const routes = createRoutesFromElements(
  <Route>
    <Route path="/" element={<Main />} />
    <Route path="/avatar" element={<AvatarPage />} />
    <Route path="/news" element={<NewsPage />} />
    <Route path="/news/:id" element={<NewsDetailPage />} />
    <Route path="/privacy" element={<PrivacyPage />} />
    <Route path="/user" element={<UserPage />} />
    <Route path="/voucher" element={<VoucherPage />} />
    <Route path="/*" element={<Main />} />
  </Route>,
);

export default routes;